<template lang="pug">
  .report
    .button
      PButton(color="success" size="md" @click="generate('pdf')" :loading="loading.pdf" :disabled="!valid") gerar pdf
      PButton(color="success" size="md" @click="generate('excel')" :loading="loading.excel" :disabled="!valid") gerar excel

</template>

<script>
export default {
  props: {
    reportInfo: {type: Object},
    valid: {type: Boolean}
  },
  data () {
    return {
      loading: {pdf: false, excel: false}
    }
  },
  methods: {
    getOptions () {
      return this.reportOptions
    },
    async generate (kind) {
      this.loading[kind] = true

      let result

      try {
        result = await this.$API.R03.get({kind}, {})
      } catch (e) {
        result = e
      }
      this.$emit('handleReport', result)

      this.loading[kind] = false
    }
  }
}
</script>

<style scoped lang="scss">
.report {
  display: grid;
  grid-row-gap: 10px;
  .button {
    display: grid;
    grid-template-columns: max-content max-content;
    grid-column-gap: 20px;
    justify-self: center;
  }
}
</style>
